import React, {useEffect, useState} from "react";
import _ from "lodash";
import RenderFields from "../../../common/ui/render-fields";
import {
    DEFAULT_SHOPIFY_BULK_PRODUCT_UPDATE_TAB,
    PRODUCT_FIELD_LIST,
    PRODUCT_SEO_FIELD_LIST,
    SHOPIFY_BULK_PRODUCT_UPDATE_TABS_LIST,
} from "../../constants/shopify.constant";
import {applyBulkPostSchedule} from "../../utils/post-util";
import {batchSaveProductsList, searchShopifyProducts} from "../../services/shopify-product-data-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowProductLink from "./show-prouct-link";
import ShowProductOptions from "./show-prouct-options";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import ShowProductImages from "./show-prouct-images";
import {CheckCircleIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {processProductListSEODetail} from "../../utils/seo-util";
import {prepareBulkProductUpdateDetails} from "../../utils/bulk-product-update-util";
import {
    addShopifyBulkProductUpdates, addSingleShopifyBulkProductUpdate,
    searchShopifyBulkProductUpdates,
    updateSingleShopifyBulkProductUpdate
} from "../../services/shopify-bulk-product-update-data-service";
import ShowTabsList from "../../../common/ui/show-tabs-list";

const tabsList = SHOPIFY_BULK_PRODUCT_UPDATE_TABS_LIST;

const BulkProductUpdate = ({
                               productsList,
                               selectedDesign,
                               refreshProductList,
                               currentBulkProductUpdate,
                               setCurrentBulkProductUpdate
                           }) => {
    const [editedProductsList, setEditedProductsList] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_SHOPIFY_BULK_PRODUCT_UPDATE_TAB);

    useEffect(() => {
        if (showModal) {
            init();
        }
    }, [showModal]);

    const init = async () => {
        const clonedProductsList = _.cloneDeep(productsList);
        processProductListSEODetail(clonedProductsList, selectedDesign);
        setEditedProductsList(clonedProductsList);

        if (_.isEmpty(currentBulkProductUpdate)) {
            await getCurrentBulkProductUpdate();
        }
    }

    const handleConfirmAction = async () => {
        setSaveInProgress(true);
        await updateCurrentBulkProductUpdate();
        setSaveInProgress(false);

        setShowModal(false);
    }

    const handleDetailChanges = (event, parentIndex, attribute?) => {
        const {name, value, type} = event.target;
        const existingEditedProductsList = [...editedProductsList];
        let existingParent = existingEditedProductsList[parentIndex];
        let currentData = existingParent;

        if (!_.isEmpty(attribute)) {
            currentData = existingParent[attribute];
        }

        if (type === 'checkbox') {
            currentData[name] = !currentData[name];
        } else if (type === 'number') {
            currentData[name] = _.parseInt(value);
        } else {
            currentData[name] = value;
        }

        if (!_.isEmpty(attribute)) {
            existingParent[attribute] = currentData;
        } else {
            existingParent = currentData;
        }

        existingEditedProductsList[parentIndex] = existingParent;
        setEditedProductsList(existingEditedProductsList);
    }

    const getCurrentBulkProductUpdate = async () => {
        let bulkProductUpdateResult;
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'status', condition: '==', value: 'NEW'});

        let bulkProductUpdateResultList = await searchShopifyBulkProductUpdates(searchCriteriaList);

        if (_.isEmpty(bulkProductUpdateResultList)) {
            const newBulkProductUpdate: any = {
                status: 'NEW',
            }

            newBulkProductUpdate.createdAt = new Date();
            newBulkProductUpdate.updatedAt = newBulkProductUpdate.createdAt

            const newBulkProductUpdateResult: any = await addSingleShopifyBulkProductUpdate(newBulkProductUpdate);
            newBulkProductUpdate.id = newBulkProductUpdateResult.id;
            bulkProductUpdateResult = newBulkProductUpdate;
        } else {
            bulkProductUpdateResult = bulkProductUpdateResultList[0];
        }

        setCurrentBulkProductUpdate(bulkProductUpdateResult);
    }

    const updateCurrentBulkProductUpdate = async () => {
        const existingEditedProductsList = [...editedProductsList];
        const existingCurrentBulkProductUpdate = {...currentBulkProductUpdate};

        existingCurrentBulkProductUpdate.productUpdates = prepareBulkProductUpdateDetails(existingEditedProductsList, existingCurrentBulkProductUpdate.productUpdates, selectedDesign);
        existingCurrentBulkProductUpdate.total = (_.keys(existingCurrentBulkProductUpdate.productUpdates)).length;
        await updateSingleShopifyBulkProductUpdate(existingCurrentBulkProductUpdate);

        setCurrentBulkProductUpdate(existingCurrentBulkProductUpdate);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            <button
                className="button-green px-3 py-2"
                onClick={() => setShowModal(true)}>
                Bulk Products Update
            </button>

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full mx-auto max-w-full">
                            {/*content*/}
                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5">
                                    <h3 className="text-lg font-semibold">
                                        Bulk Shopify Products Update ({editedProductsList?.length})
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>

                                    <div className="mr-2 flex justify-center items-center">
                                        <div className="">
                                            <button
                                                className="button-gray-outline px-3 py-2"
                                                onClick={handleCloseAction}>
                                                <div className="">
                                                    <XMarkIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/*body*/}

                                <div className="relative">

                                    <div className="w-full">

                                        <div>
                                            <ShowTabsList
                                                setSelectedTab={setSelectedTab}
                                                selectedTab={selectedTab}
                                                tabsList={tabsList}/>
                                        </div>


                                        <div className="flex-auto bg-gray-100 overflow-y-scroll">

                                            <div className="shopify-product-bulk-update-container px-6">
                                                {selectedTab?.key === 'bulk-update-fields' &&
                                                    <>
                                                        {editedProductsList?.length > 0 &&
                                                            <table className="w-full">
                                                                <thead className="">
                                                                <tr>
                                                                    <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                                                    <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Product</th>
                                                                    <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">SEO
                                                                        Title & Description
                                                                    </th>
                                                                    <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Description
                                                                        HTML
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody className="">
                                                                {editedProductsList?.map((product, productIndex) => (
                                                                    <tr key={`row-${productIndex}`}
                                                                        className="border border-gray-400">
                                                                        <td className="p-2 border border-gray-400 m-auto w-20">
                                                                            <div className="flex justify-center">
                                                                                {productIndex + 1}
                                                                            </div>
                                                                        </td>

                                                                        <td className="p-2 border border-gray-400 m-auto justify-center w-1/4">
                                                                            <div className="">
                                                                                <ShowProductLink product={product}/>
                                                                            </div>
                                                                            <div className="">
                                                                                <ProductImageSmall
                                                                                    imageUrl={product?.images[0]?.url}/>
                                                                            </div>
                                                                            <div className="font-semibold">
                                                                                {product?.title}
                                                                            </div>
                                                                            <div className="">
                                                                                {selectedDesign?.parent}
                                                                            </div>
                                                                            <div className="">
                                                                                {selectedDesign?.themeName}
                                                                            </div>
                                                                            <div className="">
                                                                                {selectedDesign?.quoteName}
                                                                            </div>
                                                                        </td>

                                                                        <td className="p-2 border border-gray-400 w-1/3">
                                                                            <div
                                                                                className="flex flex-wrap justify-start">

                                                                                <div
                                                                                    className="mx-2 flex justify-between w-full">
                                                                                    <div
                                                                                        className="w-1/2">
                                                                                    <span
                                                                                        className="font-semibold">Title:</span> {product?.seo?.title?.length}
                                                                                    </div>
                                                                                    <div
                                                                                        className="w-1/2">
                                                                                    <span
                                                                                        className="font-semibold">Description:</span> {product?.seo?.description?.length}
                                                                                    </div>
                                                                                </div>

                                                                                <RenderFields
                                                                                    parentForm={product.seo}
                                                                                    handleDetailChanges={(event) => {
                                                                                        handleDetailChanges(event, productIndex, 'seo')
                                                                                    }}
                                                                                    fieldList={PRODUCT_SEO_FIELD_LIST}
                                                                                    enableEdit={true}
                                                                                    noFieldLabel={true}
                                                                                    fieldClassName={'w-full'}/>
                                                                            </div>
                                                                        </td>

                                                                        <td className="p-2 border border-gray-400 w-full">
                                                                            <div
                                                                                className="flex flex-wrap justify-start">
                                                                                <RenderFields
                                                                                    parentForm={product}
                                                                                    handleDetailChanges={(event) => {
                                                                                        handleDetailChanges(event, productIndex)
                                                                                    }}
                                                                                    fieldList={PRODUCT_FIELD_LIST}
                                                                                    enableEdit={true}
                                                                                    noFieldLabel={true}
                                                                                    fieldClassName={'w-full'}/>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </table>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-6 border-t border-gray-500">

                                    <button
                                        className="text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>

                                    {selectedTab?.key === 'bulk-update-fields' &&
                                        <>
                                            <button
                                                className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={handleConfirmAction}>
                                                Confirm Bulk Update
                                            </button>
                                            <div className="ml-4 -mt-1">
                                                <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default BulkProductUpdate
